// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__reloadRequiredMessage__pSgr6","wrapperShow":"wrapperShow__reloadRequiredMessage__bVZtH","notification":"notification__reloadRequiredMessage__KPhXs"};